import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Jumps to the top of the page on route change, except when a hash anchor (e.g. `#faq`) is present. */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
